import { Route } from '@/app/router'

const ShipmentBillingGroups = () => import('./index.vue')
const BillingGroups = () => import('./BillingGroups/index.vue')
const AccountBillingGroups = () => import('./AccountBillingGroups/index.vue')

const CommonProps = ['page', 'perPage']

export default new Route('/shipment-billing-groups', ShipmentBillingGroups)
	// .as('Dashboard:ShipmentBillingGroups')
	.props(CommonProps)
	.permissions(['VIEW_SHIPMENT_BILLING_GROUPS'])
	.children([
		new Route('/', BillingGroups).as('Dashboard:ShipmentBillingGroups').props(CommonProps).permissions(['IS_ADMIN']),
		new Route('account', AccountBillingGroups).as('Dashboard:AccountBillingGroups').props(CommonProps)
	])
